import type { PopperPlacementType } from '@mui/material';
import type { ReactElement } from 'react';
import Popper from '../Popper';
import DateRangeLayout from './DateRangeLayout';
import DateRangeProvider from './DateRangeProvider';
import DateRangeTrigger from './DateRangeTrigger';
import type { TimeSpan } from './types';
import { toInputFormat } from './utils';

export interface DateRangeOnChangeEvent {
  from: Date;
  to: Date;
}

export interface DateRangeProps {
  from?: Date;
  onChange: (event: DateRangeOnChangeEvent) => void;
  to?: Date;
  iconButton?: boolean;
  // Maximum selectable time range in seconds
  max?: number;
  placement?: PopperPlacementType;
  timeSpan?: TimeSpan;
  Trigger?: (props: any) => ReactElement;
}

const DateRange = ({
  from,
  to,
  iconButton,
  max,
  onChange,
  placement = 'bottom-end',
  timeSpan,
  Trigger = DateRangeTrigger,
}: DateRangeProps) => {
  return (
    <DateRangeProvider
      iconButton={iconButton}
      initialValue={[toInputFormat(from), toInputFormat(to)]}
      max={max}
      onChange={(range = []) => {
        const from = range[0] ? new Date(range[0]) : new Date();
        const to = range[1] ? new Date(range[1]) : new Date();
        onChange({
          from,
          to,
        });
      }}
      timeSpan={timeSpan}
    >
      <Popper
        Content={DateRangeLayout}
        Trigger={Trigger}
        placement={placement}
      />
    </DateRangeProvider>
  );
};

export default DateRange;
